//* Libraries imports
import z from "zod";

//* Schemas imports
import { nameSchema } from "../../name";


export const paginatedExam = z.object({
  id: z.number(),
  name: nameSchema,
  totalQuestions: z.number(),
  disciplinesCount: z.number(),
});

export type PaginatedExam = z.infer<typeof paginatedExam>;